import React from 'react';
import ConnectFour from "./ConnectFour/ConnectFour";

function App() {
  return (
    <div className="App">
      <ConnectFour/>
    </div>
  );
}

export default App;
